import { render, staticRenderFns } from "./EditDeliveryOn.vue?vue&type=template&id=11385a17&scoped=true&"
import script from "./EditDeliveryOn.vue?vue&type=script&lang=js&"
export * from "./EditDeliveryOn.vue?vue&type=script&lang=js&"
import style0 from "./EditDeliveryOn.vue?vue&type=style&index=0&id=11385a17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11385a17",
  null
  
)

export default component.exports